// extracted by mini-css-extract-plugin
export var borderRadius = "_6f-4";
export var large = "_6f-3";
export var logoContainer = "_6f-0";
export var nameLogo = "_6f-2";
export var small = "_6f-1";